import classNames from "classnames";

export const setClassNamesByCount = (count: number | "*"): string =>
	classNames({
		"text-danger": typeof count === "number" && count > 0,
		"text-primary": count === "*",
		"text-success": typeof count === "number" && count <= 0,
	});
